import type { MenuOptionType } from "@dexteel/mesf-core";
import { Delete as DeleteIcon } from "@mui/icons-material";
import { Edit as EditIcon } from "@mui/icons-material";
import { FileCopy as ContentCopyIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { CatalogGrade } from "../../../models/CatalogGrade";

type Props = {
  setGrade: (grade: CatalogGrade) => void;
  setShowModal: (modal: "new" | "edit" | "delete" | "") => void;
  handleNewGrade: Function;
};
export const useGradeOptionsFunctions = ({
  setGrade,
  setShowModal,
  handleNewGrade,
}: Props) => {
  const getMenuOptions = (data: CatalogGrade) => {
    let options: MenuOptionType[] = [];
    options = options.concat([
      {
        name: "New Grade",
        key: "new_grade",
        onClick: () => {
          handleNewGrade();
        },
        icon: <PlaylistAddIcon />,
      },
    ]);
    if (data) {
      options = options.concat([
        {
          name: "Edit Grade",
          key: "edit_grade",
          onClick: () => {
            setGrade(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
        {
          name: "Delete Grade",
          key: "delete_grade",
          onClick: () => {
            setGrade(data);
            setShowModal("delete");
          },
          icon: <DeleteIcon />,
        },
        {
          name: "Duplicate Grade",
          key: "duplicate_grade",
          onClick: () => {
            setGrade({
              ...data,
              GradeName: `${data.GradeName} (Copy)`,
              IsDuplicate: true,
            });
            setShowModal("new");
          },
          icon: <ContentCopyIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
